import Pickup from "../../Models/Pickup";
import Shipment from "../../Models/Shipment";
import Unit from "../../Models/Unit";

export const GET_PICKUPS = "Pickup/getPickups";
export const UPDATE_PICKUP = "Pickup/updatePickup";
export const SAVE_PICKUP = "Pickup/savePickup";
export const GET_SHIPMENTS_BY_PICKUP = "Pickup/getShipmentsByPickup";
export const DELETE_SHIPMENT = "Pickup/deleteShipment";
export const GET_UNITS_BY_SHIPMENT = "Pickup/getUnitsByShipment";
export const CANCEL_PICKUP = "Pickup/cancelPickup";

export interface PickupReducerType {
  pickups: Pickup[];
  pPending: Pickup[];
  pScheduled: Pickup[];
  pPickups: Pickup[];
  pCanceled: Pickup[];
  shipmentsByPickup: Shipment[];
  shipments: Shipment[];
  unitsByShipment: Unit[];
}

export interface IPickupSearch {
  vehicle?: string;
  client?: string;
  date?: Date
}

export interface IShipmentSearch {
  pickup: string;
  name?: string;
  last_name?: string;
  phone?: string;
}
